export default "__VITE_ASSET__BpZ7xqP2__"